import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseQueryParams } from '@/types/generic-responses.types';
import { IResponsePaginateRaw, SocieteDacListItem } from '@/types';

@Injectable({
  providedIn: 'root',
})
export class PaymentJustificationService {
  private readonly BASE_URL = `${environment.api.paramsUrl}/societe-dac`;

  httpClient = inject(HttpClient);

  getAll(params?: BaseQueryParams): Observable<IResponsePaginateRaw<SocieteDacListItem>> {
    return this.httpClient.get<IResponsePaginateRaw<SocieteDacListItem>>(`${this.BASE_URL}/forAdmin`, {
      params: params as HttpParams,
    });
  }

  downloadJustificationDocument(justifPaymentId: number): Observable<Blob> {
    return this.httpClient.post(
      `${this.BASE_URL}/download/JustifPayement/${justifPaymentId}`,
      {},
      {
        responseType: 'blob',
      }
    );
  }

  approve(dacId: number, dacVersion: number, societeId: number): Observable<any> {
    return this.httpClient.post(`${this.BASE_URL}/acceptPaiement/${dacId}/${dacVersion}/${societeId}`, {});
  }

  reject(dacId: number, dacVersion: number, societeId: number): Observable<any> {
    return this.httpClient.post(`${this.BASE_URL}/rejectPaiement/${dacId}/${dacVersion}/${societeId}`, {});
  }
}
